export default "__VITE_ASSET__D1S8kIgg__"